<template>
	<v-container fluid class="grey lighten-3" grid-list-sm>
		<v-row>
			<v-col class="font-weight-black grey text-xs-center black--text py-1">
				<h3>اجزای نصب</h3>
			</v-col>
		</v-row>
		<v-row wrap class="justify-center">
			<v-col cols="12" sm="6" md="3" pa-2 v-for="(item, idx) in items" :key="idx">
				<v-hover>
					<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
						<v-card-title class="font-weight-black black--text justify-center">{{ item.text
							}}</v-card-title>

						<v-responsive>
							<v-img :src="item.image" contain height="100px"></v-img>
						</v-responsive>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0"
								:href="item.link" target="_blank">دانلود</v-btn>
						</v-card-actions>
					</v-card>
				</v-hover>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "SetupTools",
	computed: {
		items() {
			const linksData = this.$store.state.filesLinks;
			let links = {}
			// links = {
			// 	fonts: {
			// 		image: require("@/assets/img/Downloads/font.jpg"),
			// 		text: " مجموعه فونت",
			// 		link: "",
			// 	},
			// 	sms: {
			// 		image: require("@/assets/img/Downloads/sms.jpg"),
			// 		text: " سرویس پیامک",
			// 		link: "",
			// 	},
			// 	soapsdk: {
			// 		image: require("@/assets/img/Downloads/soap.jpg"),
			// 		text: "سرویس Soap",
			// 		link: "",
			// 	},
			// 	serviceinstaller: {
			// 		image: require("@/assets/img/Downloads/server.jpg"),
			// 		text: "راه انداز قفل شبکه",
			// 		link: "",
			// 	},
			// };
			// for (let index = 0; index < linksData.length; index++) {
			// 	const element = linksData[index];
			// 	if (element.Name.toLowerCase() === "fonts") {
			// 		links.fonts.link = element.Link;
			// 	}
			// 	if (element.Name.toLowerCase() === "sms") {
			// 		links.sms.link = element.Link;
			// 	}
			// 	if (element.Name.toLowerCase() === "soapsdk") {
			// 		links.soapsdk.link = element.Link;
			// 	}
			// 	if (element.Name.toLowerCase() === "serviceinstaller") {
			// 		links.serviceinstaller.link = element.Link;
			// 	}
			// }
			// --
			for (let index = 0; index < linksData.length; index++) {
				const element = linksData[index];
				if (element.CategoryId == 3) {
					links[`index${index}`] = { text: element.Caption, link: element.Link, image: element.ImageLink }
				}
			}
			return links;
		},
	},
	// mounted: function () {
	// 	// this.getItemsLinks();
	// 	const linksData = this.$store.state.filesLinks;
	// 	for (let index = 0; index < linksData.length; index++) {
	// 		const element = linksData[index];
	// 		if (element.Name.toLowerCase() === "fonts") {
	// 			this.items.fonts.link = element.Link;
	// 		}
	// 		if (element.Name.toLowerCase() === "sms") {
	// 			this.items.sms.link = element.Link;
	// 		}
	// 		if (element.Name.toLowerCase() === "soapsdk") {
	// 			this.items.soapsdk.link = element.Link;
	// 		}
	// 		if (element.Name.toLowerCase() === "serviceinstaller") {
	// 			this.items.serviceinstaller.link = element.Link;
	// 		}
	// 	}
	// },
};
</script>

<style>
.text-block {
	background-color: rgba(0, 0, 0, 0.644);
}
</style>
